import React, { useEffect } from "react";
import { withExplorer } from "../../layout/Explorer";
import { useSelector } from "../../store";
import {isAuthenticated, isIdleAccount} from "../../reducer/iam/authReducer";
import Box from "../../lib/appfuse-react/component/Box";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import { Typography, useTheme } from "@material-ui/core";
import Paper from "../../lib/appfuse-react/component/Paper";
import Image from "../../lib/appfuse-react/component/Image";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import {Redirect, useHistory} from "react-router-dom";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

function Home(props) {
    const { disabled } = props;
    const history = useHistory();
    const theme = useTheme();
    const router = useRouter();
    const prompt = usePrompt();
    const training = router.resolve(theme.brand.training);
    const teachers = router.resolve(theme.brand.teachers);
    const students = router.resolve(theme.brand.students);
    const information = router.resolve(theme.brand.information);
    const courses = router.resolve(theme.brand.courses);
    const searchbar = router.resolve(theme.brand.searchbar);
    const authenticated = useSelector(isAuthenticated);
    const idle = useSelector(isIdleAccount);
    const responsive = useResponsive();

    const isMobile = !responsive.isLargeScreen();

    useEffect(() => {
    }, []);

    const content = isMobile ? (
        <Paper className="app-home" fullWidth fullHeight disabled={disabled} display="flex" flexWrap={'wrap'} gap={3} padding={3} overflow={'auto'}>
            <Paper backgroundImage={courses} width="100%" height={'50%'} display="flex"
                   alignItems="flex-end" justifyContent="center" onClick={() => history.push('/courseAnnouncement')}  >
                <Paper backgroundOpacity={0.4} padding={2} fullWidth>
                    <Typography variant="h2" align="center">課程公告</Typography>
                </Paper>
            </Paper>
            <Paper backgroundImage={information} width="100%" height={'50%'} display="flex"
                   alignItems="flex-end" justifyContent="center" position="relative" onClick={() => history.push('/otherInfo')}>
                <Paper backgroundOpacity={0.4} padding={2} fullWidth>
                    <Typography variant="h2" align="center">其他資訊</Typography>
                </Paper>
                <Box fullWidth position="absolute" top="10%" display="flex" justifyContent="center">
                    <Image value={searchbar} width="80%" />
                </Box>
            </Paper>
            <Paper backgroundImage={students} height={'50%'} display="flex" width={'100%'}
                   alignItems="flex-end" justifyContent="center" onClick={() => history.push('/logon')} >
                <Paper backgroundOpacity={0.4} padding={2} fullWidth>
                    <Typography variant="h2" align="center">學員專區</Typography>
                </Paper>
            </Paper>
            <Paper backgroundImage={teachers} height={'50%'} display="flex" width={'100%'}
                   alignItems="flex-end" justifyContent="center" onClick={() => history.push('/logon')} >
                <Paper backgroundOpacity={0.4} padding={2} fullWidth >
                    <Typography variant="h2" align="center">講師專區</Typography>
                </Paper>
            </Paper>
        </Paper>
    ) : (
        <Paper className="app-home" fullWidth fullHeight disabled={disabled} padding={4} display="flex" gap={3}>
            <Paper backgroundImage={training} fullHeight width="49%" />
            <Box display="flex" gap={3} fullHeight width="49%" flexDirection="column" >
                <Box display="flex" fullHeight fullWidth gap={3}>
                    <Paper backgroundImage={courses} width="50%" fullHeight display="flex"
                           alignItems="flex-end" justifyContent="center" onClick={() => history.push('/courseAnnouncement')}  >
                        <Paper backgroundOpacity={0.4} padding={2} fullWidth>
                            <Typography variant="h2" align="center">課程公告</Typography>
                        </Paper>
                    </Paper>
                    <Paper backgroundImage={information} width="50%" fullHeight display="flex"
                           alignItems="flex-end" justifyContent="center" position="relative" onClick={() => history.push('/otherInfo')}>
                        <Paper backgroundOpacity={0.4} padding={2} fullWidth>
                            <Typography variant="h2" align="center">其他資訊</Typography>
                        </Paper>
                        <Box fullWidth position="absolute" top="10%" display="flex" justifyContent="center">
                            <Image value={searchbar} width="80%" />
                        </Box>
                    </Paper>
                </Box>
                <Box display="flex" fullHeight fullWidth gap={3} >
                    <Paper backgroundImage={students} width="50%" fullHeight display="flex"
                           alignItems="flex-end" justifyContent="center" onClick={() => history.push('/logon')} >
                        <Paper backgroundOpacity={0.4} padding={2} fullWidth>
                            <Typography variant="h2" align="center">學員專區</Typography>
                        </Paper>
                    </Paper>
                    <Paper backgroundImage={teachers} width="50%" fullHeight display="flex"
                           alignItems="flex-end" justifyContent="center" onClick={() => history.push('/logon')} >
                        <Paper backgroundOpacity={0.4} padding={2} fullWidth >
                            <Typography variant="h2" align="center">講師專區</Typography>
                        </Paper>
                    </Paper>
                </Box>
            </Box>
        </Paper>
    ) ;

    const route = authenticated && !idle ? <Redirect to="/main" /> : content;

    return route;
}

function HomeImage() {
    return (
        <Home disabled />
    )
}


export default withExplorer(Home);

export { HomeImage };